import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your data is protected with 256-bit SSL encryption'
    },
    {
      icon: 'Lock',
      title: 'Privacy First',
      description: 'We never share your personal information'
    },
    {
      icon: 'CheckCircle',
      title: 'GDPR Compliant',
      description: 'Full compliance with data protection regulations'
    }
  ];

  const testimonials = [
    {
      name: 'Sarah Chen',
      role: 'Marketing Director',
      company: 'TechFlow Inc.',
      content: 'PitchEngine AI has transformed how we create marketing prompts. The AI suggestions are incredibly accurate.',
      rating: 5
    },
    {
      name: 'Michael Rodriguez',
      role: 'Content Creator',
      company: 'Creative Studios',
      content: 'The categorized prompts feature saves me hours of work. Highly recommend for any creative professional.',
      rating: 5
    }
  ];

  return (
    <div className="space-y-8">
      {/* Security Features */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {trustFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg">
            <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={16} color="var(--color-success)" />
            </div>
            <div className="min-w-0">
              <h4 className="text-sm font-medium text-text-primary">{feature?.title}</h4>
              <p className="text-xs text-text-secondary leading-tight">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Testimonials */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-text-primary text-center">
          Trusted by 10,000+ Professionals
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {testimonials?.map((testimonial, index) => (
            <div key={index} className="bg-surface border border-border rounded-lg p-4">
              <div className="flex items-center space-x-1 mb-2">
                {[...Array(testimonial?.rating)]?.map((_, i) => (
                  <Icon key={i} name="Star" size={14} color="var(--color-warning)" />
                ))}
              </div>
              
              <p className="text-sm text-text-secondary mb-3 leading-relaxed">
                "{testimonial?.content}"
              </p>
              
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                  <span className="text-xs font-medium text-primary">
                    {testimonial?.name?.split(' ')?.map(n => n?.[0])?.join('')}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-text-primary">{testimonial?.name}</p>
                  <p className="text-xs text-text-secondary">
                    {testimonial?.role}, {testimonial?.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Legal Links */}
      <div className="flex justify-center space-x-6 text-xs text-text-secondary">
        <button 
          onClick={() => alert('Privacy Policy would open here')}
          className="hover:text-text-primary transition-smooth underline"
        >
          Privacy Policy
        </button>
        <button 
          onClick={() => alert('Terms of Service would open here')}
          className="hover:text-text-primary transition-smooth underline"
        >
          Terms of Service
        </button>
        <button 
          onClick={() => alert('Cookie Policy would open here')}
          className="hover:text-text-primary transition-smooth underline"
        >
          Cookie Policy
        </button>
      </div>
    </div>
  );
};

export default TrustSignals;